export default __webpack_public_path__ + "static/media/redo.e77d0694.svg";